import React, { useEffect, useState } from "react";
import { getEventsinner } from "../Service/Api";
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
function Events() { 
  useEffect(() => {
    document.title = 'Events - CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 

const [data, setData] = useState([]);
const [filterData, setFilteredData] = useState([]);
const [selectedYear, setSelectedYear] = useState("All");
const [selectedMonth, setSelectedMonth] = useState("All");
const [yearRanges, setYearRanges] = useState([]);
const [monthOptions, setMonthOptions] = useState(["All"]);
const [searchQuery, setSearchQuery] = useState("");

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth();

useEffect(() => {
    const fetchData = async () => {
        const galleryData = await getEventsinner(); 
        setData(galleryData);

        // Get unique years from events (sorted in ascending order)
        const uniqueYears = Array.from(new Set(galleryData.map((item) => item.date ? new Date(item.date).getFullYear() : null).filter(Boolean)));
        uniqueYears.sort((a, b) => a - b);
        setYearRanges(["All", ...uniqueYears.map(year => `${year}`)]);

        // Get unique months
        const uniqueMonths = Array.from(new Set(galleryData.map((item) => item.date ? new Date(item.date).getMonth() : null).filter(Boolean)));
        const sortedMonths = uniqueMonths.sort((a, b) => a - b).map(month => monthNames[month]);
        setMonthOptions(["All", ...sortedMonths]);
    };
    fetchData();
}, []);

useEffect(() => {
    let filteredData = [...data];

    // Filter by selected year
    if (selectedYear !== "All") {
        filteredData = filteredData.filter((item) => {
            if (item.date) {
                const year = new Date(item.date).getFullYear();
                return parseInt(selectedYear) === year;
            }
            return false;
        });
    }

    // Filter by selected month
    if (selectedMonth !== "All") {
        filteredData = filteredData.filter((item) => {
            if (item.date) {
                const month = new Date(item.date).getMonth();
                return monthNames[month] === selectedMonth;
            }
            return false;
        });
    }

    // Search filter
    if (searchQuery) {
        filteredData = filteredData.filter((item) =>
            item.title.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }

    // Separate current month events from others
    const currentMonthEvents = filteredData.filter((item) => {
        if (item.date) {
            const eventDate = new Date(item.date);
            return eventDate.getFullYear() === currentYear && eventDate.getMonth() === currentMonth;
        }
        return false;
    });

    // Remaining events sorted in ascending order (earliest events first)
    const otherEvents = filteredData.filter((item) => !currentMonthEvents.includes(item));
    otherEvents.sort((a, b) => new Date(a.date) - new Date(b.date));

    // Combine: Current month events first, then all others in ascending order
    setFilteredData([...currentMonthEvents, ...otherEvents]);
}, [data, selectedYear, selectedMonth, searchQuery]);
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                 
                <li>Events</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Events</h2>
            </div>
          </div> 
          <div className="row tabs-dynamic">
          <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="count-val">
                  <p>Total Count: {filterData.length} </p>
              </div>
          </div>
          <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="month-selection">
                  <select
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(e.target.value)}
                      className="yearSelection">
                      {yearRanges.map((yr) => (
                          <option key={yr} value={yr}>{yr}</option>
                      ))}
                  </select>
              </div>
          </div>
          <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="month-selection">
                  <select
                      value={selectedMonth}
                      onChange={(e) => setSelectedMonth(e.target.value)}
                      className="monthSelect">
                      {monthOptions.map((month, index) => (
                          <option key={index} value={month}>{month}</option>
                      ))}
                  </select>
              </div>
          </div>
          <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="searchBox">
                  <input
                      type="text"
                      id="myInput"
                      name="name"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Search Here.."
                  />
              </div>
          </div>
      </div>
      <div className="row years showYear">
          {filterData.length > 0 &&
              filterData.map((item, index) => (
                  <div className="col-md-12 eventCount" key={index}>
                      <div className="event-blk">
                          <div className="inr-event-blk">
                              <div className="inr-event-img">
                                  <LazyLoad>
                                      {item?.images.length > 0 ? (
                                          <img src={`https://webapi.entab.info/api/image/${item?.images[0]}`} alt="Gallery" className="img-fluid" />
                                      ) : (
                                          <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/events.jpg" alt="Gallery Placeholder" className="img-fluid" />
                                      )}
                                  </LazyLoad>
                              </div>
                              <div className="inr-event-content">
                                  <h6 className="date">{item.date}</h6>
                                  <h3>{item.title}</h3>
                                  <p>{item.description}</p>
                                  <h6 className="loc">
                                      <i className="bi bi-geo-alt"></i>{item.venue} <span><i className="bi bi-alarm"></i> {item.time}</span>
                                      {item.attachments && item.attachments.length > 0 && (
                                          <Link to={`https://webapi.entab.info/api/image/${item?.attachments}`} target="_blank">
                                              <span> View Attachment <i className="bi bi-arrow-right"></i> </span>
                                          </Link>
                                      )}
                                  </h6>
                              </div>
                          </div>
                      </div>
                  </div>
              ))}
      </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Events;
